import { styled } from '@mui/material/styles';
import { Accordion, AccordionSummary, Box, IconButton, LinearProgress, Typography } from '@mui/material';

export const ReportIconButton = styled(IconButton)({
  marginRight: '0.25rem'
});

export const StyledAccordion = styled(Accordion)({
  overflowX: 'hidden',
  boxSizing: 'border-box'
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  flexDirection: 'row-reverse'
});

export const LessonNameBox = styled(Box)({
  width: '30%'
});

export const UnderlinedTypography = styled('span')({
  textDecoration: 'underline'
});

export const PercentageBox = styled(Box)({
  width: '10%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right'
});

export const StyledLinearProgress = styled(LinearProgress)({
  width: '60%',
  height: '40%',
  maxHeight: '9px'
});

export const PointsBox = styled(Box)({
  width: '80px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  whiteSpace: 'nowrap'
});

export const HistoricalAccordion = styled(Accordion)({
  border: 'none',
  boxShadow: 'none'
});

export const HistoricalAccordionSummary = styled(AccordionSummary)({
  flexDirection: 'row-reverse',
  border: 'none'
});

// TODO: shouldForwardProp can be removed when updated to MUI 5.4 or later
export const PointsTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{ isCompleted: boolean }>(({ isCompleted, theme }) => ({
  color: isCompleted ? 'inherit' : theme.palette.red.main
}));